import { render, staticRenderFns } from "./ProfileApps.vue?vue&type=template&id=f4905396&scoped=true"
import script from "./ProfileApps.vue?vue&type=script&lang=js"
export * from "./ProfileApps.vue?vue&type=script&lang=js"
import style0 from "./ProfileApps.vue?vue&type=style&index=0&id=f4905396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4905396",
  null
  
)

export default component.exports